import React from "react";
import { Box, Typography, Stack, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import ProcessCard from "../components/ProcessCard";
import { processData } from "../data/vizapData";

const ProcessContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#F5F2F0",
  padding: "100px 0",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    padding: "60px 0",
  },
}));

const ProcessSection = () => {
  return (
    <ProcessContainer>
      <Container maxWidth="xl">
        <Stack spacing={8}>
          {/* Section Header */}
          <Stack
            component={motion.div}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            spacing={2}
            alignItems="center"
            textAlign="center"
          >
            <Typography
              sx={{
                color: "#6B4423",
                fontSize: { xs: "32px", md: "48px" },
                fontWeight: 700,
                fontFamily: "'Poppins', sans-serif",
                lineHeight: 1.2,
              }}
            >
              {processData.title}
            </Typography>
            <Typography
              sx={{
                color: "#7F7F7F",
                fontSize: { xs: "14px", md: "18px" },
                maxWidth: "800px",
                lineHeight: 1.7,
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400,
              }}
            >
              {processData.subtitle}
            </Typography>
          </Stack>

          {/* Process Cards Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(5, 1fr)",
              },
              gap: 3,
              mt: 4,
            }}
          >
            {processData.steps.map((step, index) => (
              <ProcessCard
                key={index}
                {...step}
                delay={index * 0.15}
              />
            ))}
          </Box>
        </Stack>
      </Container>
    </ProcessContainer>
  );
};

export default ProcessSection;